/**
 * Invite api script class
 *
 * @package    Api
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

export default class InviteApi {
    /**
     * Send request for load invite item by hash
     *
     * @param {String} inviteHash - Invite hash
     */
    static loadItem (inviteHash) {
        return (axios) => axios.get(`/ribyt/rsvp/${ inviteHash }`, {
            params: {
                newReg: true,
            },
        });
    }

    /**
     * Send request for load temp invite item
     *
     * @param {String} groupID - Group ID
     * @param {Object} params - Search params
     */
    static loadTempItem (groupID, params = {}) {
        return (axios) => axios.get(`/ribyt/rsvp/tempInvite/${ groupID }`, {
            params: {
                ...params,
                newReg: true,
            },
        });
    }

    /**
     * Send request for create invite item
     *
     * @param {Object} data - Invite data
     */
    static createItem (data) {
        return (axios) => axios.post('/ribyt/rsvp/', data);
    }

    /**
     * Send request for update invite item
     *
     * @param {String} inviteHash - Invite hash
     * @param {Object} data - Invite data
     */
    static updateItem (inviteHash, data) {
        return (axios) => axios.put(`/ribyt/rsvp/${ inviteHash }`, data);
    }

    /**
     * Send request for send companions invites
     *
     * @param {String} inviteHash - Invite hash
     * @param {Object} data - Invite data
     */
    static sendInvites (inviteHash, data) {
        return (axios) => axios.put(`/ribyt/rsvp/${ inviteHash }/sendinvite`, data);
    }

    /**
     * Send request for verify invite permission
     *
     * @param {Object} data - Data for invite verification
     */
    static verify (data) {
        return (axios) => axios.post('/ribyt/rsvp/confirmPermission', data);
    }
}
